module.exports = __webpack_public_path__ + "static/media/08.8994ebc6.png";